/*
SaiKrishna 10/06/2022 3075154998 Removed unnecessary console.log statements
Akhila  10/28/2022 3075154998 data manager ux changes
*/
import React from 'react';
import AddDMRecordGroupForm from './AddDMRecordGroupForm';

const AddDMRecordGroup = ({filterCode, setFilterCode, setValue}) => {
  return (
    <>
      <AddDMRecordGroupForm filterCode={filterCode} setValue={setValue}/>
    </>
  );
};

export default AddDMRecordGroup;
